import { apiConfig } from '../../services/apiConfig';

export const CM_BASE_URL = apiConfig.serviceApiCM || apiConfig.serviceApi;
export const AMLS_REPORT_BASE_URL = `${apiConfig.serviceApi}/common/report`;
export const CM_BASE_ROUTE = '/app/cm';
export const CASE_LIST_ROUTES = {
  BY_DEPARTMENT: 'cases-by-department',
  BY_INVESTIGATOR: 'cases-by-investigator'
};

export const ALERT_LIST_ROUTE = 'alerts';
export const CASE_LIST_ROUTE = 'cases';

export const PAGE_SIZE_OPTIONS = [5, 10, 25, 50, 100];

// FIN-13957 — server cap of POST /alerts/bulkUpdateStatus (AlertsController: "Maximum 100 alerts
// per bulk update"), enforced client-side by the shared bulk modal. FRAML View selects whole
// customers, so it can exceed it; the CM Alert List keeps selections across pages
// (preserveSelectedRowKeys) but disables Bulk Update for cross-page selections (FIN-10962), so it
// stays within one page of at most 100.
export const MAX_BULK_STATUS_UPDATE_ALERTS = 100;
export const DEFAULT_PAGE_SIZE = 10;
export const HISTORY_ITEMS_PER_PAGE = 10;
export const CROSS_GROUP_TAG_LABEL = 'Cross-Group';
export const CUSTOMERS_PER_PAGE = 10;
export const USER_GROUP_PER_PAGE = 5;
export const ALERT_STATUSES = [
  'UNASSIGNED',
  'ASSIGNED',
  'WORK_IN_PROGRESS',
  'RE_OPENED',
  'NO_ISSUE',
  'HIBERNATE',
  'AUTO_HIBERNATE'
];

export const ALERT_SOURCE_IDS = {
  TMSAM: 'TMSAM',
  TMSAM_ANOMALY: 'TMSAM_ANOMALY',
  NSIAD: 'NSIAD',
  NSSAM: 'NSSAM',
  TSSAM: 'TSSAM',
  CRS_FIRST_TIME_RISK: 'CRS_FIRST_TIME_RISK',
  CRS_PERIODIC_REVIEW: 'CRS_PERIODIC_REVIEW',
  CRS_RISK_CHANGE: 'CRS_RISK_CHANGE',
  CRS_OTHERS: 'CRS_OTHERS',
  TMIAD: 'TMIAD',
  NSIAD_RUN_INSTANCE: 'NSIAD_RUN_INSTANCE',
  TMIAD_RUN_INSTANCE: 'TMIAD_RUN_INSTANCE',
  TSIAD: 'TSIAD',
  CRS_PRIORITISE_ALERT: 'CRS_PRIORITISE_ALERT',
  FRAUDIAD: 'FRAUDIAD',
  RTFRAUDIAD: 'RTFRAUDIAD',
  RTFRAUDIAD_BATCH: 'RTFRAUDIAD_BATCH',
  ON_DEMAND_NS_SINGLE: 'ON_DEMAND_NS_SINGLE',
  ON_DEMAND_NS_BATCH: 'ON_DEMAND_NS_BATCH',
  PS: 'PS',
  INACTIVE_MONTHLY: 'INACTIVE_MONTHLY'
};

export const RT_FRAUD_SOURCE_IDS = ['RTFRAUDIAD', 'RTFRAUDIAD_BATCH'];

// AML TM (transaction-monitoring IAD) sources shown in the FRAML Case Summary
// "Case AML TM Alerts" card. Scope per FRAML-view decision = TM IAD Production.
export const AML_TM_SOURCE_IDS = ['TMIAD', 'TMIAD_RUN_INSTANCE'];

export const ALERT_SOURCE_APPS = {
  TM: 'Transaction Monitoring',
  NS: 'Name Screening',
  TS: 'Transaction Screening',
  CRS: 'Customer Risk Scoring',
  PS: 'Prospect Screening'
};

export const ALERT_SOURCE_APP_BY_SOURCE_ID = {
  [ALERT_SOURCE_IDS.TMSAM]: ALERT_SOURCE_APPS.TM,
  [ALERT_SOURCE_IDS.TMSAM_ANOMALY]: ALERT_SOURCE_APPS.TM,
  [ALERT_SOURCE_IDS.NSIAD]: ALERT_SOURCE_APPS.NS,
  [ALERT_SOURCE_IDS.NSSAM]: ALERT_SOURCE_APPS.NS,
  [ALERT_SOURCE_IDS.TSSAM]: ALERT_SOURCE_APPS.TS,
  [ALERT_SOURCE_IDS.CRS_FIRST_TIME_RISK]: ALERT_SOURCE_APPS.CRS,
  [ALERT_SOURCE_IDS.CRS_PERIODIC_REVIEW]: ALERT_SOURCE_APPS.CRS,
  [ALERT_SOURCE_IDS.CRS_RISK_CHANGE]: ALERT_SOURCE_APPS.CRS,
  [ALERT_SOURCE_IDS.CRS_OTHERS]: ALERT_SOURCE_APPS.CRS,
  [ALERT_SOURCE_IDS.TMIAD]: ALERT_SOURCE_APPS.TM,
  [ALERT_SOURCE_IDS.NSIAD_RUN_INSTANCE]: ALERT_SOURCE_APPS.NS,
  [ALERT_SOURCE_IDS.TMIAD_RUN_INSTANCE]: ALERT_SOURCE_APPS.TM,
  [ALERT_SOURCE_IDS.TSIAD]: ALERT_SOURCE_APPS.TS,
  [ALERT_SOURCE_IDS.PS]: ALERT_SOURCE_APPS.PS,
  [ALERT_SOURCE_IDS.INACTIVE_MONTHLY]: ALERT_SOURCE_APPS.NS
};

export const ALERT_LEVELS = ['LOW', 'GOOD', 'HIGH'];

export const ALERT_LEVEL_COLORS = {
  [ALERT_LEVELS[0]]: '#71C969',
  [ALERT_LEVELS[1]]: '#E29840',
  MEDIUM: '#E29840',
  [ALERT_LEVELS[2]]: '#DF6057'
};

export const CASE_CLOSURE_STATUSES = [
  'ISSUE_NOT_STR',
  'NO_ISSUE',
  'ISSUE_REPORT_STR'
];

// FIN-11261 / FIN-12254: Terminal (resolved/closed) alert statuses —
// Investigators must not be able to bulk-update them. Must match
// StatusTransitions.resolvedAlertStatus on the backend (the set actually
// enforced by AlertsService's Investigator authorization checks), not
// HIBERNATE/AUTO_HIBERNATE which aren't part of that rule.
// Terminal ("Closed") alert statuses. Union of the two definitions that evolved
// independently on the release branches and collided in the 6.3.4 carry-forward:
//   prerelease/v6.4.0 (FIN-11261 / FIN-11272, alert-list bulk modal + FRAML tabs):
//     NO_ISSUE, HIBERNATE, AUTO_HIBERNATE
//   prerelease/v6.3.4 (FIN-12254, case bulk-status modal):
//     NO_ISSUE, ISSUE_NOT_STR, ISSUE_REPORT_STR
// All five are genuine closure outcomes, and every consumer uses this list to
// GATE actions, so the union keeps both branches' gating rather than silently
// dropping one side's. Taking either branch's list alone would un-gate the other's.
export const ALERT_CLOSURE_STATUSES = [
  'NO_ISSUE',
  'ISSUE_NOT_STR',
  'ISSUE_REPORT_STR',
  'HIBERNATE',
  'AUTO_HIBERNATE'
];

export const CASE_STR_STATUS = ['ISSUE_REPORT_STR'];
export const CASE_NOTSTR_STATUS = ['ISSUE_NOT_STR', 'NO_ISSUE'];

export const CASE_STATUSES = [
  'UNASSIGNED',
  'ASSIGNED',
  'WORK_IN_PROGRESS',
  'ON_HOLD',
  'RE_OPENED',
  ...CASE_CLOSURE_STATUSES
];

export const DEFAULT_STATUSES = [
  'UNASSIGNED',
  'ASSIGNED',
  'WORK_IN_PROGRESS',
  'ON_HOLD',
  'RE_OPENED',
  'NO_ISSUE',
  'HIBERNATE',
  'AUTO_HIBERNATE',
  'ISSUE_NOT_STR',
  'ISSUE_REPORT_STR'
];

export const DEFAULT_DATE_RANGE_DAYS = 30;

export const ALERT_STATUS_TRANSITIONS = {
  UNASSIGNED: ['ASSIGNED', 'HIBERNATE'],
  ASSIGNED: ['UNASSIGNED', 'WORK_IN_PROGRESS', 'NO_ISSUE', 'HIBERNATE'],
  RE_OPENED: ['ASSIGNED', 'NO_ISSUE'],
  WORK_IN_PROGRESS: ['NO_ISSUE', 'HIBERNATE'],
  NO_ISSUE: ['RE_OPENED'],
  HIBERNATE: ['ASSIGNED'],
  AUTO_HIBERNATE: ['ASSIGNED']
};

export const CASE_ALERT_STATUS_TRANSITIONS = {
  UNASSIGNED: ['ASSIGNED', 'NO_ISSUE'],
  ASSIGNED: [
    'WORK_IN_PROGRESS',
    'ISSUE_NOT_STR',
    'ISSUE_REPORT_STR',
    'NO_ISSUE'
  ],
  RE_OPENED: ['ASSIGNED', 'ISSUE_NOT_STR', 'ISSUE_REPORT_STR', 'NO_ISSUE'],
  WORK_IN_PROGRESS: [
    'ON_HOLD',
    'ISSUE_NOT_STR',
    'ISSUE_REPORT_STR',
    'NO_ISSUE'
  ],
  ON_HOLD: [
    'WORK_IN_PROGRESS',
    'ISSUE_NOT_STR',
    'ISSUE_REPORT_STR',
    'NO_ISSUE'
  ],
  ISSUE_NOT_STR: ['RE_OPENED'],
  ISSUE_REPORT_STR: ['RE_OPENED'],
  NO_ISSUE: ['RE_OPENED']
};

export const DOWNLOAD_SCREENS = {
  CASES_BY_DEPARTMENT: 'cases',
  CASES_BY_INVESTIGATOR: 'cases',
  ALERT_LIST: 'alerts',
  ALERT_RETRY_HISTORY: 'retry-history'
};

export const ALLOWED_UPLOAD_FILE_TYPES = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'text/plain',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/zip',
  'application/x-zip-compressed'
];

export const HISTORY_ITEM_ACTION_TYPES = {
  CHANGE_STATUS: 'CHANGE_STATUS',
  ASSIGN_USER: 'ASSIGN_USER',
  ASSIGN_DEPARTMENT: 'ASSIGN_DEPARTMENT',
  ADD_NOTE: 'ADD_NOTE',
  ATTACH_FILE: 'ATTACH_FILE',
  CHECK_REQUESTED: 'CHECK_REQUESTED',
  CHECK_PASSED: 'CHECK_PASSED',
  CHECK_NOT_PASSED: 'CHECK_NOT_PASSED',
  MERGE_ALERT_TO_CASE: 'MERGE_ALERT_TO_CASE',
  CONVERT_ALERT_TO_CASE: 'CONVERT_ALERT_TO_CASE',
  CHANGE_CASE_NAME: 'CHANGE_CASE_NAME',
  AUTO_ASSIGN_CASE: 'AUTO_ASSIGN_CASE',
  AUTO_MERGE_ALERT_TO_CASE: 'AUTO_MERGE_ALERT_TO_CASE'
};

export const REVIEW_STATUSES = {
  CHECK_NEEDED: 'CHECK_NEEDED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CHECK_NOT_NEEDED: 'CHECK_NOT_NEEDED'
};

export const CASE_TYPE = {
  AUTOMATION_CASE: 'AUTOMATION_CASE',
  MANUAL_CASE: 'MANUAL_CASE'
};

export const STR_POLLING_INTERVAL_MS = 10000;

export const SETTINGS_LIST_ROUTES = {
  EMAIL_PREFERENCES: 'email-preferences',
  USER_GROUP: 'user-group',
  GENERAL_SETTINGS: 'general-settings',
  AUTOMATION: 'automation',
  WORKFLOW_STATUS: 'alert-case-status-name',
  AGE_SETTINGS: 'age-settings'
};

export const CASE_SEARCH_OPTIONS = [
  { label: 'Customer ID', value: 'customer-id' },
  { label: 'Customer Name', value: 'customer-name' },
  { label: 'Case ID', value: 'case-id' },
  { label: 'Case Subject', value: 'case-subject' },
  { label: 'Alert ID', value: 'alert-id' },
  { label: 'Account Number', value: 'acc-no' },
  { label: 'Activity ID', value: 'activity-id' },
  { label: 'Investigation Notes', value: 'notes' },
  { label: 'Transaction ID', value: 'transaction-id' },
  { label: 'Watchlist ID', value: 'watchlist-id', shouldValidate: true },
  { label: 'Watchlist Name', value: 'watchlist-name', shouldValidate: true },
  // FIN-12644: the 'Watchlist Category' SEARCH option was removed here. It was the only caller of
  // `watchlist-category-search`, a free-text FULLTEXT + `LIKE '%...%'` over the 70M-row
  // alert_watchlist table -- its COUNT alone measured 512s on dev-1 and timed the listing out.
  // Watchlist Category is now reachable only as an exact multi-select FILTER, which stays on the
  // (watchlist_category(50), alert_id) index. The BE param is left in place for other clients.
  { label: 'Customer ID Number', value: 'party-id-no' },
  { label: 'Merchant Reg Number', value: 'registered-number' }
];

export const APPROVAL_STATUSES = {
  CHECK_NEEDED: 'CHECK_NEEDED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CHECK_NOT_NEEDED: 'CHECK_NOT_NEEDED'
};

export const USER_ROLES = {
  ADMIN: 'ADMIN',
  CHECKER: 'CHECKER',
  SUPERVISOR: 'SUPERVISOR',
  INVESTIGATOR: 'INVESTIGATOR',
  INVESTIGATOR_PLUS: 'INVESTIGATOR_PLUS'
};

export const PLACEHOLDER_INPUT = 'Please input';
export const PLACEHOLDER_SELECT = 'Please select';

export const REPORTS_ROUTES = {
  REGULATORY_REPORT: 'regulatory-report',
  OPERATIONAL_REPORT: 'operational-report',
  REGULATORY_REPORT_CTR: 'ctr-report'
};

export const CTR_STR_MAX_CUSTOM_FIELDS =
  parseInt(process.env.CTR_STR_MAX_CUSTOM_FIELDS, 10) || 20;

export const CTR_STR_DEFAULT_MAX_CUSTOM_REGEX =
  process.env.CTR_STR_DEFAULT_MAX_CUSTOM_REGEX || '^.{1,150}$';

export const DATE_FORMAT = 'DD/MM/YYYY';

export const APPROVAL_STATUS_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'Approved by the User', value: 'APPROVED' },
  { label: 'Pending Approval', value: 'CHECK_NEEDED' },
  { label: 'Rejected by the User', value: 'REJECTED' },
  { label: 'Closed Without Approval', value: 'CHECK_NOT_NEEDED' },
  { label: 'Others', value: 'NA' }
];

export const CHARACTER_COUNT = 50;
export const PARTY_NAME_CHARACTER_COUNT = 300;
export const ALERT_SCORE_DEFAULT_VALUE = [50.0, 100.0];
export const NOTE_MAX_ALLOWED_CHARACTERS = 5000;

export const AGE_METHOD_NAMES = {
  HOUR24: 'METHOD_24_HOURS',
  MIDNIGHT: 'METHOD_MIDNIGHT',
  REOPENED_DATE: 'REOPENED_DATE',
  DEFAULT_DATE: 'CREATED_DATE'
};

export const WHITELIST_STATUS = {
  APPROVED: 'Approved',
  PENDING_APPROVAL: 'Pending Approval',
  REJECTED: 'Rejected'
};

export const AUTOMATION_ASSIGN_TYPES = {
  BY_WORKLOAD: 'BY_WORKLOAD',
  BY_USER: 'BY_USER',
  BY_BEHAVIOUR: 'BY_BEHAVIOUR'
};

export const AUTOMATION_TYPES = {
  DETECTION: 'DETECTION',
  PREVENTION: 'PREVENTION',
  REAL_TIME_SCREENING: 'REAL_TIME_SCREENING',
  PROSPECT_SCREENING: 'PROSPECT_SCREENING'
};

export const WHITELIST_TYPES = {
  USER_GENERATED: 'Custom',
  SYSTEM_GENERATED: 'Default'
};

export const MESSAGE_DURATION = 7;

export const TICKET_DASHBOARD_TYPES = {
  CASE: 'Case',
  GENERAL: 'General'
};

// FIN-12644: how many options to pull per dropdown in one request.
//
// The four small dropdowns are fetched WHOLE so their type-to-narrow search runs client-side over
// the complete list. Measured on dev-1 (the watchlist_filter_* lookup tables that feed
// GET /cm/alerts/watchlist/{field}): category 89 values / 4.5KB, external_source 96 / 1.7KB,
// watchlist_source 121 / 1.6KB, subcategory 205 / 4.6KB -- ~12KB for all four, so one request each.
// 500 is ~2.4x the largest of them, i.e. headroom, not a fit to today's numbers.
export const WATCHLIST_OPTIONS_FULL_LIST_LIMIT = 500;

// Keyword is the exception: 7,041 distinct values / ~482KB on dev-1. Shipping that to the browser
// on every alert-list mount is not worth it, so it stays paginated and searches server-side.
export const WATCHLIST_OPTIONS_PAGE_LIMIT = 100;

// `limit` is only an optimisation. The dropdown decides client-side vs server-side search from the
// DATA it actually holds (`data.length >= total`), so a deployment whose list outgrows the limit
// falls back to server-side search automatically instead of silently searching a truncated list.
export const WATCHLIST_TYPES = [
  {
    key: 'watchlistCategory',
    apiEndpoint: 'category',
    label: 'Category',
    limit: WATCHLIST_OPTIONS_FULL_LIST_LIMIT
  },
  {
    key: 'watchlistSubCategory',
    apiEndpoint: 'subcategory',
    label: 'Sub Category',
    limit: WATCHLIST_OPTIONS_FULL_LIST_LIMIT
  },
  {
    key: 'watchlistKeyword',
    apiEndpoint: 'keyword',
    label: 'Keyword',
    limit: WATCHLIST_OPTIONS_PAGE_LIMIT
  },
  {
    key: 'externalSource',
    apiEndpoint: 'external_source',
    label: 'External Source',
    limit: WATCHLIST_OPTIONS_FULL_LIST_LIMIT
  },
  {
    key: 'watchlistSource',
    apiEndpoint: 'watchlist_source',
    label: 'Source',
    limit: WATCHLIST_OPTIONS_FULL_LIST_LIMIT
  }
];
